// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const OptionsIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="OptionsIcon" ref={forwardedRef} {...props}>
      <path d="M17 5.75H9.996v-1.5H17z" />
      <path d="M3 4.25h3.996v1.5H3z" />
      <path d="M11 9.25H3v1.5h8z" />
      <path d="M14 9.25v1.5h3v-1.5z" />
      <path d="M9 14.25h8v1.5H9z" />
      <path d="M6 14.25H3v1.5h3z" />
      <path d="M6 16.5v-3h1.5v3z" />
      <path d="M14 11.5v-3h-1.5v3z" />
      <path d="M6.996 6.5v-3h1.5v3z" />
    </SvgIcon>
  );
});

/**
 * configurations that only influence a selected area and preferences. Use ChartTools for charts
 * @public
 */
export const OptionsIcon = /* @__PURE__ */ Object.assign(OptionsIconComponent, {
  displayName: 'OptionsIcon',
});
